module.exports = __webpack_public_path__ + "img/icon-instagram.043b8acc2cd7747c7173354dfbbb0e8b.svg";